import { Name } from '@massilia/ui'
import { useMatches } from '@tanstack/react-router'

import { useAuthStore } from '@/stores/auth.store'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /**
     * Copie du bandeau de l'espace client. Portée par la route plutôt que par la
     * page : le héro vit dans le layout, et chaque onglet ne rend que son
     * contenu. `title` absent = « Bonjour {prénom} ».
     */
    hero?: { subtitle: string; title?: string }
  }
}

/**
 * Bandeau bleu commun aux trois onglets. Il lit le `staticData` de la route la
 * plus profonde qui en déclare un ; une page sans `hero` n'en affiche aucun (le
 * détail d'un dossier, par exemple, a sa propre mise en page).
 */
export function ClientHero() {
  const matches = useMatches()
  const { user } = useAuthStore()

  const hero = [...matches].reverse().find((match) => match.staticData.hero)?.staticData.hero

  if (!hero) return null

  return (
    <section className="relative overflow-hidden bg-brand-600 px-6 py-8 md:px-28 md:py-10">
      <img
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-50"
        src="/images/customer-arear-background.jpg"
      />
      <div className="relative z-10 flex flex-col gap-2">
        <h1 className="text-3xl font-semibold tracking-tight text-white md:text-5xl">
          {hero.title ?? (
            <>
              Bonjour <Name>{user?.firstName}</Name>
            </>
          )}
        </h1>
        <p className="text-sm font-medium text-white">{hero.subtitle}</p>
      </div>
    </section>
  )
}
